import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=3f16cae2&scoped=true"
import script from "./Result.vue?vue&type=script&setup=true&lang=js"
export * from "./Result.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Result.vue?vue&type=style&index=0&id=3f16cae2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f16cae2",
  null
  
)

export default component.exports